export default __webpack_public_path__ + "static/media/648.9f155824.gif";